import React, { useEffect, useState } from 'react'
import './selectOnMap.css'
import { GoogleMap, MarkerF, StandaloneSearchBox } from '@react-google-maps/api'
import point from '../../assets/pin.svg'
import { Button, Card, IconButton, InputBase, Paper } from '@mui/material'
import { geoCode } from '../../services/map/map'
const mapContainerStyle = { height: '70vh', width: '80vw' }
let coordinates

export default function SelectOnMap ({ props }) {
  const { handleFormMap, currentLocation, handleLocation, location } = props
  const [mapref, setMapRef] = useState(null)
  const [center, setCenter] = useState(currentLocation)
  const [address, setAddress] = useState('')
  const [search, setSearch] = useState() // handle by standAloneSearchBox
  const handleOnLoad = map => {
    setMapRef(map)
  }

  const handleCenterChanged = () => {
    if (mapref) {
      const newCenter = mapref.getCenter()
      const coordinate = { lat: newCenter.lat(), lng: newCenter.lng() }
      coordinates = { lat: newCenter.lat(), lng: newCenter.lng() }
      debounce(coordinate)
    }
  }

  let timerId
  function debounce (coordinate) {
    if (timerId) {
      clearTimeout(timerId)
    }
    timerId = setTimeout(async () => {
      geoCode(coordinate).then((result) => {
        if (result) setAddress(result)
      })
    }, 800)
  }
  // Search place Autocomplete
  const onSBLoad = (ref) => {
    setSearch(ref)
  }
  const onPlacesChanged = () => {
    let results
    if (search) results = search.getPlaces()
    let selectedPlace
    if (results && results.length > 0) {
      selectedPlace = { lat: results[0].geometry?.location?.lat(), lng: results[0].geometry?.location?.lng() }
      setCenter(selectedPlace)
      debounce(selectedPlace)
    }
  }

  useEffect(() => {
    if (center) debounce(currentLocation)
    // eslint-disable-next-line
  }, [])

  return (
    <Card sx={{ padding: ' 10px', zIndex: 100 }}>
      <div className='map-autocomplete-close-container'>
        <StandaloneSearchBox
          onLoad={onSBLoad}
          onPlacesChanged={onPlacesChanged}
        >
          <>
            <Paper
              component='form'
              sx={{ mb: '7px', p: '1px', display: 'flex', zIndex: 100 }}
            >
              <IconButton sx={{ marginBottom: '5px', width: '50px' }} onClick={() => handleFormMap(false)} id='close-map-btn' aria-label='back'>
                <span data-toggle='tooltip' title='Close' className='material-symbols-outlined' style={{ padding: '1px', color: 'black', fontSize: '25px', fontWeight: 'bold' }}> keyboard_backspace </span>
              </IconButton>
              <InputBase
                data-dismiss='modal'
                sx={{ px: '10px', flex: 1, fontSize: '18px', border: '1px solid', borderRadius: '7px' }}
                placeholder='Search area / locality / landmark'
              />
              <IconButton data-toggle='tooltip' title='Search' sx={{ p: '10px' }} aria-label='search'>
                <span style={{ fontSize: '30px', color: 'black' }} className='material-symbols-outlined'> search </span>
              </IconButton>
            </Paper>
          </>
        </StandaloneSearchBox>
      </div>

      <GoogleMap
        center={center}
        zoom={18}
        onLoad={(map) => handleOnLoad(map)}
        onCenterChanged={handleCenterChanged}
        mapContainerStyle={mapContainerStyle}
        options={{ streetViewControl: false, clickableIcons: false, fullscreenControl: false }}
      >
        <>
          {currentLocation && <MarkerF
            position={currentLocation}
            onLoad={marker => {
              marker.setIcon(
                {
                  path: 0,
                  scale: 10,
                  fillColor: 'green',
                  fillOpacity: 1,
                  strokeWeight: 5,
                  strokeColor: '#b4fa8e'
                }
              )
            }}
                              />}
          {location && <MarkerF
            position={{ lat: location[1], lng: location[0] }}
                       />}
          <img style={{ position: 'relative', left: '50%', top: '45%', transform: 'translate(-50%, -50%)' }} width='50px' src={point} alt='point' />
        </>
      </GoogleMap>

      <div className='address-picker-container'>
        <p id='show-address'>{address || ' '} </p>
        <Button
          color='primary' variant='contained' sx={{ marginTop: '5px', p: '5px 20px' }} onClick={() => {
            handleLocation(coordinates)
            handleFormMap(false)
          }} id='select-location-btn'
        >Select this Address
        </Button>
      </div>
    </Card>
  )
}
